'use strict';

var StepSposPanelDirective = function StepSposPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-spos-panel.html'),
    controller: 'StepSposPanelController',
    scope: {
      entity: '=',
      defaultGridOptions: '='
    },
    link: function link(scope) {
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
    }
  };
};
StepSposPanelDirective.$inject = [];
module.exports = StepSposPanelDirective;